import { defineStore } from 'pinia'
// import { getOrderData } from '@/service/orderDataService'
import {ref} from "vue";
import {sendOrderData} from "@/service/orderService";
import {UseOrderStore} from "@/stores/orderStore";
import {useI18n} from "vue-i18n";

export const useOrderDataStore = defineStore('orderDataStore', {
    state: () => ({
        order: ref(null),
        token: ref(null),
        payment: ref([]),
        shippingCountry: ref(null),
        deliveryAddress: ref(null),
        refundMethods: ref([]),
        lines: ref([]),
        serviceCost: ref(null),
        loading: ref(false),
        error: ref(null),
        rmaId: ref(null),
    }),

    actions: {
        async fetchOrder() {
            this.loading = true
            this.error = null
            try {
                const data = await sendOrderData({
                    order: UseOrderStore().order,
                    email: UseOrderStore().email
                }, useI18n().locale.value);
                console.log("data: ",data)
                // Split parts of the response into separate reactive states
                this.order = data.order;
                this.token = data.token;
                this.shippingCountry = data.shippingCountry;
                this.refundMethods = data.refundMethods;
                this.deliveryAddress = data.deliveryAddress;
                this.lines = data.lines;
                this.serviceCost = data.serviceCost;

            } catch (err) {
                this.error = err.message
            } finally {
                this.loading = false
            }
        },

        clearOrderData() {
            this.order = null
            this.payment = []
            this.shippingCountry = null
            this.deliveryAddress = null
            this.lines = []
            this.refundMethods = []
            this.rmaId = null
        },

        setRmaId(id) {
            this.rmaId = id;
        },

        clearRmaId() {
            this.rmaId = null;
        },
    },
    persist:true
})
